import {
  api_url
} from '../config.js';
import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home.vue'
import detail from '../views/detail.vue'
import detail1 from '../views/detail1.vue'
import shop from '../views/shop.vue'
import fangancart from '../views/fangancart.vue'
import fangandetail from '../views/fangandetail.vue'
Vue.use(Router)

export default new Router({
  //暂时只能配置hash，也就是地址栏有#，如果用history的话，二级页面直接访问404问题，目前无法规避。
  mode: "hash",
  routes: [{
    path: '/',
    name: 'home',
    component: home,
    meta: {
      //isUseCache: true, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
      title: '首页'

    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '商品详情'

    }
  },
  {
    path: '/detail1',
    name: 'detail1',
    component: detail1,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '商品详情'

    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: shop,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '礼册详情'

    }
  },
  {
    path: '/fangancart',
    name: 'fangancart',
    component: fangancart,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '采购蓝'

    }
  },
  {
    path: '/fangandetail',
    name: 'fangandetail',
    component: fangandetail,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '采购详情'

    }
  }
  ],


})



// WEBPACK FOOTER //
// ./src/router/index.js